export default __webpack_public_path__ + "static/media/shape8.d798156b.svg";